import {comparators, comparatorsPred, objToArrK} from "../tools/CommonJS";
import {doesSearchIncTpc, severitiesDefsArr, severitiesDefs} from "./CommonUIData";
import BenchmarkTypes from "compliance-types/ComplianceTypes.json";
import complianceRemedies from "compliance-types/ComplianceRemedies.json";
export const Comp_remedies = complianceRemedies.remediations;
export const Benchmark_topics = BenchmarkTypes.benchmark_orgs;
export const Benchmark_rules = Benchmark_topics.cis.rules;
export const Benchmark_controls = BenchmarkTypes.controls["8.0"];
export const Benchmark_cisProfiles = BenchmarkTypes.benchmark_orgs.cis.profiles, Benchmark_cisProfilesArr = objToArrK(Benchmark_cisProfiles);

export const c_framework = "8.0";

// remove from description any html elements not P / SPAN / STRONG / LI / UL
export const replaceDescForbiddenTags = (descStr) => descStr?.replace(/<(?!\/?(p|span|strong|li|ul)\b)[^>]*>(.*?)<\/(?!\/?(p|span|strong|li|ul)\b)[^>]*>/ig, "");

export function xBenchmark_Repo(rowData) {
    const currRepo = Benchmark_rules[rowData.topicCode];

    return currRepo ? {...currRepo, severity: (rowData.severity || "Unknown"), description: replaceDescForbiddenTags(currRepo?.description)} : {
        frameworks: {},
        title: "Unknown: " + rowData.topicCode + ". Please upgrade the software to the latest version.",
        severity: rowData.severity || "Unknown",
        profiles: [],
        description: "",
        unrecognized: true
    };
}

export const  cisLevelDefs = {
        "Level 1": {h: "CIS - Level 1", shortH: "L1", comb: "*Level_1*"},
        "Level 2": {h: "CIS - Level 2", shortH: "L2", comb: "*Level_2*"},
        "STIG": {h: "STIG", shortH: "STIG", comb: "*STIG*"}
    }, cisLevelOpts = objToArrK(cisLevelDefs);

export const getControlDefs = (controlKey) => {
    const parentControl = Benchmark_controls[controlKey.split(":")[0]];

    return parentControl ? controlKey.includes(":") ? {
        ...parentControl.controls[controlKey],
        parent: parentControl
    } : parentControl : {
        title: controlKey === "unmapped" ? "Standards Not Mapped to Controls" : "Unknown: " + controlKey + ". Please upgrade the software to the latest version.",
        description: "",
        label: controlKey
    };
};

export const getControlsFromRules = (filteredData) => {
    const availableControls = filteredData?.reduce((acc, rule) => {
        const ruleControls = xBenchmark_Repo(rule).frameworks[c_framework];
        !ruleControls ?
            (acc.unmapped ?? (acc.unmapped = [])).push(rule)
            : ruleControls?.forEach(control => (acc[control] ?? (acc[control] = [])).push(rule));
        return acc;
    }, {});
    const mainControls = Object.entries(availableControls).groupBy(([control]) => control.split(":")[0]);

    return [{h: "All", k: "All", n: filteredData.length}, ...Object.entries(mainControls).map(([k, subControls]) => {
        const control = getControlDefs(k);
        return ({
            k:  k || "unmapped", h: control?.title, n: subControls.reduce((acc, [_, control]) => acc + control.length, 0),
            subMenu: subControls.map(([subK, rules]) => ({k: subK || "unmapped", h: getControlDefs(subK)?.title, n: rules.length}))
        });
    })].filter(c => c?.n);
};

const values = ["devicesOk", "devicesBad", "mutedAlerts"];

export const getTypesProfile = profile => profile.includes("Application") ? profile.split("_Version")[0] : profile;

// Proxy object: always transforms id via getTypesProfile before lookup
export const Benchmark_cisProfilesById = new Proxy(
    Benchmark_cisProfilesArr.toObj((o, bench) => o[bench.id] = bench),
    {
        get(target, prop, receiver) {
            if (typeof prop === "string") {
                // If the property is a profile id, return a Proxy for the profile object
                const value = getTypesProfile(prop);
                const obj = target[value];
                if (prop.includes("Application"))
                // Return a Proxy to intercept property access like ".title"
                    return new Proxy(obj, {
                        get(profileObj, profileProp) {
                            if (profileProp === "title" && prop.includes("Application"))
                                return profileObj.title !== profileObj.level ?  `${profileObj.title} ${prop.after("Version_")}`
                                    : `${profileObj.level} - ${
                                        prop.after("Application_").before("Version_").replace(/_/g, " ")}  ${
                                        prop.after("Version_")} (App)`;

                            return profileObj[profileProp];
                        }
                    });

                return obj;
            }
            return Reflect.get(target, prop, receiver);
        }
    }
);

const aggregateIfNeeded = (tpc, obj) => {
    if (!obj[tpc.topicCode]) return {};
    return Object.fromEntries(values.map(key => [key, (obj[tpc.topicCode]?.[key] || 0) + tpc[key]]));
};

export const filterSortComp = (topics, pinTopics, {level, control, search, os, severities, sortBy, application, view}, applicationOpts) => {
    const removeTpcWithSameLevel = {};
    if (application && application !== "All" && applicationOpts && !applicationOpts.includes(application)) application = "All";

    topics?.forEach(tpc => {
        if ((!(pinTopics && view?.includes("pinned")) || pinTopics.has(tpc.topicCode)) &&
            Benchmark_cisProfilesById[tpc.profile]?.level === level &&
            (!application || application === "All" || tpc.profile.includes("Application") && genAppNameFromProfile(tpc.profile) === application))
            removeTpcWithSameLevel[tpc.topicCode] = {...tpc, ...aggregateIfNeeded(tpc, removeTpcWithSameLevel),
                profiles: [...(removeTpcWithSameLevel[tpc.topicCode]?.profiles || []), tpc.profile].undup(),
                oss: [...(removeTpcWithSameLevel[tpc.topicCode]?.oss || []), tpc.os].undup()
            };
    });

    let severityVals = [{k: severitiesDefs.passed.idx, v: 0}, {k: severitiesDefs.unknown.idx, v: 0}];
    const data = Object.values(removeTpcWithSameLevel);
    const osOpts = ["All", ...data.map(rule => rule.oss).flat().undup()];
    const controlsOpts = getControlsFromRules(data);

    if (os && os !== "All" && (osOpts && !osOpts.includes(os))) os = "All";

    const filteredData = data.filter(tpc => {
        const repo = xBenchmark_Repo(tpc);

        const matched = (!search || doesSearchIncTpc(repo, search)) &&
            (!os || (os ==="All" || tpc.oss?.includes(os))) &&
            (!control || control === "All" || (control !== "unmapped" ?
                repo.frameworks[c_framework]?.some(f => f.startsWith(control))
                : !repo.frameworks[c_framework]?.length
            ));

        if (matched)
            severityVals[tpc.devicesBad ? 1 : 0].v++;


        const hasSeverityFilter = (!severities?.length || severities.some(sevIdx =>
            severitiesDefsArr.find(({idx}) => idx === sevIdx)?.k === "passed" ? (tpc.devicesBad === 0) : tpc.devicesBad));

        return matched && hasSeverityFilter;
    });
    if (sortBy && compSortDefs[sortBy])
        filteredData.sort(compSortDefs[sortBy].sort);

    return {filteredData, osOpts, severityVals, controlsOpts};
};

export const filterDeviceComp = (topics, pinTopics, {level, control, search, compSeverities, view}) => {
    let severityVals = [{k: severitiesDefs.unknown.idx, v: 0}, {k: severitiesDefs.passed.idx, v: 0}];

    const filteredWOSevData = topics?.filter(tpc => {
        const repo = xBenchmark_Repo(tpc);


        return (!search || doesSearchIncTpc(repo, search)) &&
            (!view?.includes("pinned") || (pinTopics && pinTopics.has(tpc.topicCode))) &&
            (repo.profiles.some(profile => level === Benchmark_cisProfiles[profile]?.level));
    });

    filteredWOSevData?.forEach(tpc => severityVals[tpc.alertsBad ? 0 : 1].v++);

    const filteredData = filteredWOSevData?.filter(tpc => {
        const repo = xBenchmark_Repo(tpc);

        return (!compSeverities?.length || compSeverities.some(sevIdx =>
            severitiesDefsArr.find(({idx}) => idx === sevIdx)?.k === "passed" ? (tpc.alertsBad === 0) : tpc.alertsBad)) &&
            (!control || control === "All" || (control !== "unmapped" ?
                repo.frameworks[c_framework]?.some(f => f.startsWith(control))
                : !repo.frameworks[c_framework]?.length));
    }).sort((a, b) => comparators.stringSig(Benchmark_rules[a.topicCode].title, Benchmark_rules[b.topicCode].title));

    return {filteredData, severityVals};
};


const getCompTopicSeverityIdx = tpc => (tpc.devicesBad || tpc.alertsBad) ? 0 : 1;

export const compSortDefs = {
        devicesBad: {h: "Total Devices", sort: (a, b) =>  comparators.numberSigRev(a.devicesBad, b.devicesBad)},
        title: {h: "Alert Name", sort: comparatorsPred(comparators.stringSig, o => Benchmark_rules[o.topicCode]?.title)},
        severity: {h: "Severity", sort: (a, b) => getCompTopicSeverityIdx(a) - getCompTopicSeverityIdx(b)},
    }, compSortOpts = objToArrK(compSortDefs);

export const genAppNameFromProfile = (profile) => profile.after("Application_").split("_Version").join("").fromKebabCase();

export const getVerFromName = (name) => name.match(/_Benchmark_(v\d+\.\d+\.\d+)/)?.[1];

/*
Converts benchmarkNames `CIS_Microsoft_Windows_10_Stand-alone_Benchmark_v3.0.0-xccdf.xml` string to `CIS Microsoft Windows 10 Stand-alone Benchmark v3.0.0`
*/
export function formatBenchmarkName(name) {
    return name.beforeLast("-xccdf.xml").split("_").join(" "); // All Sensors benchmarkNames end with -xccdf.xml
}
